module.exports = __webpack_public_path__ + "img/DE00743.90fefac2.png";